<template>
  <div
    v-if="enabled"
    class="fixed right-0 top-10 w-10 h-10 bg-blue-500 rounded hover:bg-blue-600 border border-blue-800 z-50 shadow-lg"
  >
    <a
      :href="url"
      class="w-full h-full cursor-pointer flex items-center justify-center text-white"
      title="Open admin mode"
      v-html="slidersIcon.toSvg({ width: 24, height: 24 })"
    />
  </div>
</template>

<script setup>
import feather from "feather-icons";
import { computed, onMounted, ref } from "vue";

const slidersIcon = feather.icons["sliders"];

const enabled = ref(false);
const url = computed(() => {
  const url = new URL(window.location.href);

  url.pathname = `/_${url.pathname}`;

  return url.toString();
});

onMounted(() => {
  if (!window.parent || !window.parent.location.pathname.startsWith("/_/")) {
    enabled.value = true;
  }
});
</script>
